import React from "react";
import Logo from '../Assets/Images/hayya_media_logo.svg';
const Footer = () => {
    const currentYear = new Date().getFullYear();
  return (
    <div id="copyright">
      <div >
        <img src={Logo}></img>
      </div>
      <div>
          © {currentYear} Qatar Hayya | All rights reserved
      </div>
    </div>
  );
};

export default Footer;
